import request from '@/api/core/request'
import appConfig from '@/config/appConfig'
import { jsonToQueryString } from '@/helpers/helpers'
class Resource {
  constructor (uri) {
    this.uri = '/'.concat(uri)
    this.request = request
  }

  filtrar (filtros) {
    return request.post(this.uri.concat('/filtrar'), filtros)
  }

  obtener (id) {
    return request.get(this.uri.concat('/').concat(id))
  }

  guardar (data) {
    if (typeof data.id !== 'undefined' && data.id) {
      return this.update(data.id, data)
    } else {
      return this.store(data)
    }
  }

  store (resource) {
    return request.post(this.uri, resource)
  }

  update (id, resource) {
    return request({
      url: this.uri.concat('/').concat(id),
      method: 'put',
      data: resource
    })
  }

  eliminar (id) {
    return request.delete(this.uri.concat('/').concat(id))
  }

  exportar (filtros) {
    let queryString = jsonToQueryString(filtros)
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/exportar?')
          .concat(queryString)
      )
    )
  }
}

export { Resource as default }
